import { imageBackground } from './presenterHelper';

const ArticlePresenter = (function() {
  function nullArticle() {
    return {
      id: 0,
      layout: '',
      breadcrumb: '',
      title: '',
      teaser: '',
      publicUrl: '',
      mainContent: '',
      furtherContent: '',
      summary: '',
      backgroundColor: '',
      backgroundOptionForContent: '',
      callToActionText: '',
      callToActionLink: '',
      imageLeftTopUrl: '',
      imageLeftTopAlt: '',
      imageLeftBottomUrl: '',
      imageLeftBottomAlt: '',
      imageRightTopUrl: '',
      imageRightTopAlt: '',
      imageRightBottomUrl: '',
      imageRightBottomAlt: '',
      imageFullWidthUrl: '',
      imageFullWidthAlt: '',
      imageBackground: {},
      imageBackgroundTeaserSrc: '',
      imageBackgroundSrc: '',
      videoBackgroundSrc: {},
      vimeoVideo: {
        id: '',
        src: ''
      },
      youtubeVideo: {
        id: '',
        src: ''
      },
      videoPosition: '',
      imageVideoUrl: '',
      imageVideoAlt: '',
      articleForms: [],
      imageTeaserUrl: '',
      imageTeaserAlt: '',
      show_event_section: false,
      branch: {
        location: {},
        consultant_article_ids: [],
        event_article_ids: [],
        city: ''
      },
      consultant: {
        branch: {
          location: {
            city: '',
            street: '',
            zip: ''
          }
        },
        full_name: '',
        languages: '',
        qualifications: ''
      },
      report: {
        news_date: ''
      },
      event: {
        start_date: '',
        event_city: '',
        event_address: '',
        beginning: ''
      },
      pressrelease: {
        release_date: ''
      },
      widgetIds: [],
      multipleColumnsArticle: [],
      fullscreenOnepager: false
    };
  }

  const ARTICLE_LAYOUTS = {
    APPLICATION: 'application',
    NUR_RECHTE_SPALTE: 'nur_rechte_spalte',
    NUR_ZENTRIERTE_SPALTE: 'nur_zentrierte_spalte',
    QUIRION: 'quirion'
  };

  function articleContent(content, layout) {
    // return empty paragraph to preserve the columns, otherwise the
    // further content would align left
    if (!content && layout === ARTICLE_LAYOUTS.NUR_RECHTE_SPALTE) {
      return '<p></p>';
    }
    return content;
  }

  function video(video) {
    let id = '',
      src = '';

    if (video) {
      id = video.id;
      src = video.src;
    }

    return {
      id,
      src
    };
  }

  function consultant(data) {
    const mergedConsultant = data.consultant;

    if (mergedConsultant) {
      mergedConsultant.branch = {};
      mergedConsultant.branch.location = data['consultant.branch.location'];
      mergedConsultant.fullName = data['consultant.full_name'];
      mergedConsultant.languages = data['consultant.languages'];
      mergedConsultant.qualifications = data['consultant.qualifications'];
    }

    return mergedConsultant;
  }

  function getArticle(data) {
    return {
      id: data.id,
      layout: data.selected_layout,
      breadcrumb: data.breadcrumb,
      title: data.title,
      mainContent: articleContent(data.content, data.selected_layout),
      furtherContent: data.context_info,
      summary: data.summary,
      backgroundColor: data.background_color || '',
      backgroundOptionForContent: data.background_option_for_content || '',
      callToActionText: data.call_to_action ? data.call_to_action[0] : '',
      callToActionLink: data.call_to_action ? data.call_to_action[1] : '',
      imageLeftTopUrl: data.image_links_mobil_oben_content,
      imageLeftTopAlt: data.image_alt_links_mobil_oben,
      imageLeftBottomUrl: data.image_links_mobil_unten_content,
      imageLeftBottomAlt: data.image_alt_links_mobil_unten,
      imageRightTopUrl: data.image_rechts_mobil_oben_content,
      imageRightTopAlt: data.image_alt_rechts_mobil_oben,
      imageRightBottomUrl: data.image_rechts_mobil_unten_content,
      imageRightBottomAlt: data.image_alt_rechts_mobil_unten,
      imageFullWidthUrl: data.image_volle_breite_background,
      imageFullWidthAlt: data.image_alt_volle_breite,
      imageBackground: imageBackground(data.image_focus_hintergrund_mini),
      imageBackgroundTeaserSrc: data.image_focus_hintergrund_teaser[0],
      imageBackgroundSrc: data.image_focus_hintergrund_background[0],
      videoBackgroundSrc: data.video_hintergrund,
      vimeoVideo: video(data.vimeo_video),
      youtubeVideo: video(data.youtube_video),
      videoPosition: data.video_position,
      imageVideoUrl: data.image_videovorschau_content,
      imageVideoAlt: data.image_alt_videovorschau,
      articleForms: data.content_article_forms,
      show_event_section: data.show_event_section,
      branch: data.branch,
      consultant: consultant(data),
      report: data.report,
      event: data.event,
      pressrelease: data.pressrelease,
      widgetIds: data.widget_ids,
      multipleColumnsArticle: data.column_articles_ids,
      fullscreenOnepager: data.fullscreen_onepager
    };
  }

  function getIndexArticle(data) {
    return {
      title: data.title,
      teaser: data.teaser,
      publicUrl: data.public_url,
      imageTeaserUrl: data.image_teaser,
      imageTeaserAlt: data.image_teaser,
      report: data.report,
      event: data.event,
      pressrelease: data.pressrelease
    };
  }

  return {
    nullArticle,
    getArticle,
    getIndexArticle,
    ARTICLE_LAYOUTS
  };
})();

export default ArticlePresenter;



// WEBPACK FOOTER //
// ./articlePresenter.js